import React, { useEffect, useState } from 'react';
import './FeatureStyles.css';
import './EnterpriseIntegrationsFeature.css';

const EnterpriseIntegrationsAnimation = () => {
  const [activeIntegration, setActiveIntegration] = useState(0);
  const [dataFlowing, setDataFlowing] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDataFlowing(true);
      setTimeout(() => {
        setActiveIntegration(prev => (prev + 1) % 3);
        setDataFlowing(false);
      }, 1800);
    }, 3500);

    return () => clearInterval(interval);
  }, [activeIntegration]);

  return (
    <div className="feature-animation enterprise-integrations">
      <div className="integrations-hub-layout">
        {/* Jira card */}
        <div className={`integration-card jira ${activeIntegration === 0 ? 'active' : ''}`}>
          <div className="integration-icon jira">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.005 2L6 8.005l6.005 6.005L18.01 8.005 12.005 2zm0 3.536l2.469 2.469-2.469 2.469-2.469-2.469 2.469-2.469zM6 14.005L12.005 20l6.005-6.005-1.768-1.768-4.237 4.237-4.237-4.237L6 14.005z"/>
            </svg>
          </div>
          <span className="integration-name">Jira</span>
        </div>

        {/* Left spoke line */}
        <div className={`spoke-line ${activeIntegration === 0 && dataFlowing ? 'active' : ''}`} />

        {/* Central Hub */}
        <div className={`central-hub ${dataFlowing ? 'active' : ''}`}>
          <div className="hub-glow" />
          <div className="hub-icon">
            <img src="/qatelogo.png" alt="Qate" loading="lazy" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
          </div>
        </div>

        {/* Right spoke line */}
        <div className={`spoke-line ${(activeIntegration === 1 || activeIntegration === 2) && dataFlowing ? 'active' : ''}`} />

        {/* Right: Providers parent card */}
        <div className={`providers-card ${activeIntegration === 1 || activeIntegration === 2 ? 'active' : ''}`}>
          <div className="providers-row">
            {/* GitHub */}
            <div className={`provider-item ${activeIntegration === 1 ? 'active' : ''}`}>
              <div className="integration-icon github">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.026A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.026 2.747-1.026.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z"/>
                </svg>
              </div>
              <span className="provider-name">GitHub</span>
              <div className="integration-inner-card copilot">
                <div className="integration-icon-tiny copilot">
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 18v-5.5c0 -.667 .167 -1.333 .5 -2" />
                    <path d="M12 7.5c0 -1 -.01 -4.07 -4 -3.5c-3.5 .5 -4 2.5 -4 3.5c0 1.5 0 4 3 4c4 0 5 -2.5 5 -4" />
                    <path d="M4 12c-1.333 .667 -2 1.333 -2 2c0 1 0 3 1.5 4c3 2 6.5 3 8.5 3s5.499 -1 8.5 -3c1.5 -1 1.5 -3 1.5 -4c0 -.667 -.667 -1.333 -2 -2" />
                    <path d="M20 18v-5.5c0 -.667 -.167 -1.333 -.5 -2" />
                  </svg>
                </div>
                <span className="integration-inner-name">Copilot</span>
              </div>
            </div>

            {/* GitLab */}
            <div className={`provider-item ${activeIntegration === 2 ? 'active' : ''}`}>
              <div className="integration-icon gitlab">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.65 14.39L12 22.13.35 14.39c-.18-.14-.25-.37-.18-.58L2.27 8.6l2.1 6.45h15.25l2.1-6.45 2.11 5.21c.07.21 0 .44-.18.58z"/>
                  <path d="M12 22.13L17.62 15.05H6.38L12 22.13z"/>
                  <path d="M6.38 15.05L2.27 8.6 12 22.13 6.38 15.05z"/>
                  <path d="M2.27 8.6l-.92 2.83c-.08.26.01.54.23.71L12 22.13 2.27 8.6z"/>
                  <path d="M2.27 8.6h4.11L4.38 2.55c-.1-.3-.52-.3-.62 0L2.27 8.6z"/>
                  <path d="M17.62 15.05L21.73 8.6 12 22.13l5.62-7.08z"/>
                  <path d="M21.73 8.6l.92 2.83c.08.26-.01.54-.23.71L12 22.13 21.73 8.6z"/>
                  <path d="M21.73 8.6h-4.11l1.99-6.05c.1-.3.52-.3.62 0L21.73 8.6z"/>
                </svg>
              </div>
              <span className="provider-name">GitLab</span>
              <div className="integration-inner-card duo">
                <div className="integration-icon-tiny duo">
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4"/>
                  </svg>
                </div>
                <span className="integration-inner-name duo">Duo</span>
              </div>
            </div>

            {/* Bitbucket */}
            <div className="provider-item bitbucket-item">
              <div className="integration-icon-mini bitbucket">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M.778 1.211a.768.768 0 00-.768.892l3.263 19.81c.084.5.515.868 1.022.873H19.95a.772.772 0 00.77-.646l3.27-20.03a.768.768 0 00-.768-.891L.778 1.211zM14.52 15.53H9.522L8.17 8.466h7.561l-1.211 7.064z"/>
                </svg>
              </div>
              <span className="provider-name">Bitbucket</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const EnterpriseIntegrationsFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M16 8v8m-8-8v8m-4-4h16" />
      <rect x="2" y="4" width="20" height="16" rx="2" />
    </svg>
  ),
  title: "Enterprise Integrations",
  description: "Seamless connections to your existing workflow. Jira integration for automatic bug creation, story linking, and release management. GitHub, GitLab, and Bitbucket integration for codebase discovery, PR/MR analysis, and AI-powered bugfixing via Copilot or Duo. Your tests fit into your process, not the other way around.",
  animation: <EnterpriseIntegrationsAnimation />
};

export default EnterpriseIntegrationsFeature;
